import Papa from "papaparse";

class PolicyGraphAggregator {
  constructor(graphBuilder, policyData, statsData) {
    this.graphBuilder = graphBuilder;

    // Extract a table of formatted objects from OWID CSV format
    const { data: statsTable } = Papa.parse(statsData, {
       header: true,
       dynamicTyping: true
    });

    this.policyData = policyData;
    this.statsTable = statsTable;
  }

  buildGraph() {
    this.buildTaxonomy();
    this.buildEntries();
    this.buildStats();
  }

  buildTaxonomy() {
    // Add country nodes
    for (const [country, cid] of this.policyData.countries) {
      this.graphBuilder.addNode({ id: cid, label: "country", props: {
        id: cid,
        name: country
      }});
    }

    // Add intervention nodes
    for (const [intervention, iid] of this.policyData.interventions) {
      this.graphBuilder.addNode({ id: iid, label: "intervention", props: {
        id: iid,
        name: intervention
      }});
    }

    // Add sector nodes
    for (const [sector, sid] of this.policyData.sectors) {
      this.graphBuilder.addNode({ id: sid, label: "sector", props: {
        id: sid,
        name: sector
      }});
    }

    // Add category nodes
    for (const [category, ctid] of this.policyData.categories) {
      this.graphBuilder.addNode({ id: ctid, label: "category", props: {
        id: ctid,
        name: category
      }});
    }
  }

  buildEntries() {
    // Add entry nodes and join them to the graph
    for (const entry of this.policyData.entries) {
      // Add the entry node with metadata props
      this.graphBuilder.addNode({
        id: entry.id,
        label: "entry",
        props: entry
      });

      // Join the entry to its countries
      for (const cid of entry.country) {
        this.graphBuilder.addEdge({
          label: "for_country",
          from: entry.id,
          to: cid
        });
      }

      // Join the entry to its interventions
      for (const iid of entry.interventions) {
        this.graphBuilder.addEdge({
          label: "of_type",
          from: entry.id,
          to: iid
        });
      }

      // Join the entry to its sectors
      for (const sid of entry.sectors) {
        this.graphBuilder.addEdge({
          label: "for_sector",
          from: entry.id,
          to: sid
        });
      }

      // Join the entry to its categories
      for (const ctid of entry.categories) {
        this.graphBuilder.addEdge({
          label: "for_category",
          from: entry.id,
          to: ctid
        });
      }
    }
  }

  buildStats() {
    for (const row of this.statsTable) {
      const sid = `${row.iso_code}:${row.date}`;

      this.graphBuilder.addNode({
        id: sid,
        label: "daily_metrics",
        props: row
      });

      this.graphBuilder.addEdge({
        label: "metrics_of",
        from: sid,
        to: row.iso_code
      });
    }
  }
}

export default PolicyGraphAggregator;
